import { render, staticRenderFns } from "./data12.vue?vue&type=template&id=7c60f16c&scoped=true&"
import script from "./data12.vue?vue&type=script&lang=js&"
export * from "./data12.vue?vue&type=script&lang=js&"
import style1 from "./data12.vue?vue&type=style&index=1&id=7c60f16c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60f16c",
  null
  
)

export default component.exports